import { DivisionLayout } from '../components/layout/DivisionLayout';

const divisionData = {
  divisionName: 'Wear Parts',
  accentColor: '#e87722',
  heroImage: 'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/7ydta29n_image.png',
  aboutText: [
    {
      text: '<strong>Catworth Wear Parts</strong> specializes in the precision processing and fabrication of wear-resistant steel components for the mining, quarrying, and heavy equipment industries. Working with premium wear plate grades supplied by <strong>SSAB South Africa</strong>, including Hardox® wear steels, Catworth manufactures components to customer drawings for demanding abrasive applications.'
    },
    {
      text: 'Our capabilities include the <strong>cutting, bending, rolling, drilling, and welding of high-strength wear plate used in equipment operating in extreme conditions</strong>. By combining material expertise with precision manufacturing, Catworth delivers durable wear components that support the reliability and longevity of mining and yellow equipment operations.'
    }
  ],
  aboutImage: 'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/15n0v9ec_image.png',
  galleryImages: [
    'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/o9dt7303_image.png',
    'https://images.unsplash.com/photo-1653201587864-c6280a0bb4eb?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1727504172725-14acb4f32655?crop=entropy&cs=srgb&fm=jpg&q=85',
  ],
  capabilities: [
    { title: 'Wear Plate Processing', description: 'Precision cutting and processing of wear-resistant steels including Hardox® and other high-performance wear plate grades.' },
    { title: 'Manufacturing to Customer Drawings', description: 'Production of wear components manufactured exactly to client specifications and engineering drawings.' },
    { title: 'Plate Forming and Bending', description: 'Heavy-duty press brake forming of wear plate for structural and wear applications.' },
    { title: 'Plate Rolling', description: 'Rolling of wear plate components used in chutes, liners, and cylindrical wear structures.' },
    { title: 'Drilling and Machining', description: 'Precision drilling and machining of wear components to ensure accurate installation and fitment.' },
    { title: 'Stub Welding and Fabrication', description: 'Attachment of studs, brackets, and mounting hardware required for wear component installations.' },
    { title: 'Mining and Yellow Equipment Applications', description: 'Manufacturing wear components used in crushers, screens, chutes, buckets, hoppers, and other high-wear equipment.' },
  ],
};

export const WearParts = () => {
  return <DivisionLayout {...divisionData} />;
};

export default WearParts;
